<button class="csv-export-1930" [disabled]="disabled" (click)="LedgerCompanyAccountExport()">
  Exportera CSV för konto 1930
</button>
